import { BlockApplyModal } from "@/pages/supplier/SupplierProfile/components/FrozenTab/components/BlockApplyModal/BlockApplyModal";
import { SourcingRequirementApplicationModal } from "@/pages/requirementManagement/sourcingRequirementManagement/components/SourcingRequirementApplicationModal";
import { BlacklistApplyModal } from "@/pages/supplier/SupplierProfile/components/BlackListTab/components/BlacklistApplyModal/BlacklistApplyModal";
import type { ModalKey } from "./type";
import { AuditSupplierAccountModal } from "@/pages/supplier/SupplierProfile/archiveDetail/components/AuditSupplierAccountModal";
import { PurchaseContractModal } from "@/pages/contractManagement/components/PurchaseContractModal";

export const modalRegistry: Record<ModalKey, React.FC<any>> = {
  MATERIAL_BLOCK: BlockApplyModal,
  SUPPLIER_BLACK_LIST: BlacklistApplyModal,
  SOURCING_APPLICATION_20251202: SourcingRequirementApplicationModal,
  SUPPLIER_SUB_REGISTER: AuditSupplierAccountModal,
  PURCHASE_CONTRACT: PurchaseContractModal,
};
